export default __webpack_public_path__ + "static/media/mpudt.6e07dd4d.png";